import React, { useState } from "react";
//import "./styles.css";
import { Row, Col, Form } from "react-bootstrap";
// import LeftpanelMember from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./bulkuploadmember.css";
import { Members } from "../../../assets/images";

import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";
const BulkUploadMember = () => {
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);

  const uploadBadge = async (e) => {
    e.preventDefault();
    if (!file) {
      message.error("Please upload file");
      return;
    }
    setLoading(true);
    let data = new FormData();
    if (file) {
      data.append("csv", file);
      // console.log("/////",imageUrl)

      // const hideMessage = message.loading("Please wait ...", 0);
      // setBtn(true);

      await axios
        .post(`/add-bulk-members`, data, adminConfig())
        .then((res) => {
          setLoading(false);

          if (res.data.status === true) {
            message.success("added members success");
            setFile("");
          } else {
            message.error("failed adding members");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
      setLoading(false);
    } else {
      setLoading(false);
      console.log("error");
    }
  };
  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelMember />
    <div className="right_cont">
      <div className="right_banner_banner_cnt">
        <div className="travel_deals_admin">
          {/* <h2>Hello, Admin!</h2> */}
          <LoadingOverlay active={loading} spinner text="loading...">
            <div className="add_certificate">
              <h3>Upload Members</h3>
              <p>Only CSV file supported</p>
              <div className="addcert_box1">
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      {/* <Form.Control
                                                as="select"
                                                custom
                                                className='text_link bulk_select'
                                                >
                                                <option>Select</option>
                                                <option>CSV</option>
                                                <option>Green</option>
                                                <option>Black</option>
                                                <option>Orange</option>
                                            </Form.Control> */}
                      <div className="upload_btn_wrapper">
                        <button className="btn_bulk">
                          <span className="cert_bulkks">
                            <img src={Members} alt="" />
                          </span>
                          {file !== "" ? file.name : "Upload Members"}
                        </button>
                        <input
                          type="file"
                          name="myfile"
                          onChange={(e) => {
                            setFile(e.target.files[0]);
                          }}
                        />
                      </div>
                    </Form.Group>
                    <div className="sub_but">
                      <button
                        type="submit"
                        className="add_but submit_buttt mt-0"
                        onClick={uploadBadge}
                      >
                        Submit
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </LoadingOverlay>
        </div>
      </div>
    </div>
    //             </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    //     </div>
    // </div>
  );
};

export default BulkUploadMember;
